/**
 * The ‘first’ day of the week varies by culture and industry. Currently Opal
 * allows users and workspaces to explicitly choose between Sunday and Monday.
 */
export enum WeekStartsOn {
  Sunday = 0,
  Monday = 1,
  Tuesday = 2,
  Wednesday = 3,
  Thursday = 4,
  Friday = 5,
  Saturday = 6,
}
